import { SITE } from "../lib/site";
import { Plus } from "lucide-react";

export default function AddOns() {
  return (
    <section
      id="addons"
      data-testid="addons-section"
      className="relative py-28 lg:py-36 bg-[#050505] overflow-hidden"
    >
      {/* Side leather texture */}
      <div className="absolute top-0 right-0 h-full w-1/2 opacity-20 pointer-events-none hidden lg:block">
        <img
          src={SITE.media.leather}
          alt=""
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-l from-transparent to-[#050505]" />
      </div>

      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          <div className="lg:col-span-5 reveal">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-8 bg-gold" />
              <span className="text-xs uppercase tracking-[0.32em] text-gold/90">
                Add-Ons
              </span>
            </div>
            <h2 className="font-display font-light text-5xl lg:text-6xl tracking-tight">
              Tailor it to
              <span className="italic gold-shimmer"> your car</span>.
            </h2>
            <p className="mt-7 text-white/60 leading-relaxed max-w-md">
              Mix and match any of these with the package of your choice.
              Add-ons are payable at the time of service.
            </p>
          </div>

          <div className="lg:col-span-7 reveal">
            <ul className="divide-y divide-white/10 border-y border-white/10">
              {SITE.addons.map((a, i) => (
                <li
                  key={i}
                  data-testid={`addon-${i}`}
                  className="py-7 lg:py-8 flex items-center justify-between gap-6 group"
                >
                  <div className="flex items-start gap-5">
                    <Plus
                      size={18}
                      className="text-gold mt-1.5 shrink-0 transition-transform group-hover:rotate-90"
                    />
                    <div>
                      <div className="font-display text-2xl lg:text-3xl text-white tracking-tight">
                        {a.name}
                      </div>
                      <div className="mt-1 text-sm text-white/50">
                        {a.note}
                      </div>
                    </div>
                  </div>
                  <div className="font-display text-2xl lg:text-3xl text-gold whitespace-nowrap">
                    +${a.price}
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
